export enum OrderHistoryFilterFieldEnum {
  ORDER_NUMBER = 'orderNumber',
  JOB_NAME = 'jobName',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  INVOICE_START_DATE = 'invoiceStartDate',
  INVOICE_END_DATE = 'invoiceEndDate',
  ITEM_NUMBER = 'itemNumber',
  ITEM_DESCRIPTION = 'itemDescription',
  ORDER_STATUS_IDS = 'orderStatusIds',
  ORDER_SHIP_TOS = 'orderShipTos',
  PICKUP_IN_STORE = 'pickupInStore',
  MANUFACTURERS = 'manufacturers',
  ORDER_SUB_STATUS_IDS = 'orderSubStatusIds',
  CATEGORY_IDS = 'categoryIds',
  TYPE_IDS = 'typeIds',
  SORT_BY = 'sortBy',
  ORDER_FILTER = 'orderFilter',
  ADVANCED_SEARCH_EXPANDED = 'advancedSearchExpanded',
  AVAILABLE_PAGE_SIZES = 'availablePageSizes',
  RETRIGGER_KEY = 'retriggerKey'
};
